export default function noop() {}



//////////////////
// WEBPACK FOOTER
// /Users/darlacameron/projects/feature-federal-children-shelters-2018-06/node_modules/d3-swoopy-drag/node_modules/d3-geo/src/noop.js
// module id = null
// module chunks = 